// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Session templates — club board, same language as Consent / Edit Group. */
.st-board {
  --st-pine: var(--brand-primary, #0877bc);
  --st-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));
  --st-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));
  --st-muted: var(--text-secondary, #64748b);
  --st-surface: var(--surface-color, #fff);
  --st-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --st-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --st-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;
  --st-perf: #0f766e;
  --st-spar: #b45309;

  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding:
    max(0.75rem, env(safe-area-inset-top, 0px))
    max(1rem, env(safe-area-inset-right, 0px))
    calc(1.75rem + env(safe-area-inset-bottom, 0px))
    max(1rem, env(safe-area-inset-left, 0px));
  color: var(--text-color);
  font-family: var(--st-body);
}

.st-board *,
.st-board *::before,
.st-board *::after {
  box-sizing: border-box;
}

.st-board__glow {
  pointer-events: none;
  position: absolute;
  z-index: -1;
  inset: -4% -10% auto;
  height: 180px;
  opacity: 0.8;
  background:
    radial-gradient(48% 70% at 8% 18%, color-mix(in srgb, var(--st-pine) 18%, transparent) 0%, transparent 72%),
    radial-gradient(34% 48% at 92% 0%, color-mix(in srgb, #0f766e 10%, transparent) 0%, transparent 68%);
}

.st-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem 1.25rem;
  margin-bottom: 1rem;
}

.st-hero__copy {
  min-width: 0;
  max-width: 42rem;
}

.st-hero__kicker {
  margin: 0 0 0.2rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--st-muted);
}

.st-hero__title {
  margin: 0;
  font-family: var(--st-display);
  font-size: clamp(1.85rem, 3.2vw, 2.55rem);
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--st-ink);
}

.st-hero__sub {
  margin: 0.45rem 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: var(--st-muted);
  max-width: 38rem;
}

.st-hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.st-btn {
  appearance: none;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 0.55rem 1.05rem;
  font-family: var(--st-body);
  font-size: 0.86rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.18s var(--st-ease), box-shadow 0.18s var(--st-ease), background 0.18s;
}

.st-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.st-btn--primary {
  background: var(--st-pine);
  color: #fff;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--st-pine) 28%, transparent);
}

.st-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  background: var(--st-ink);
}

.st-btn--ghost {
  background: color-mix(in srgb, var(--st-pine) 8%, var(--st-surface));
  color: var(--st-ink);
  border-color: color-mix(in srgb, var(--st-pine) 28%, transparent);
}

.st-btn--ghost:hover:not(:disabled) {
  background: color-mix(in srgb, var(--st-pine) 14%, var(--st-surface));
}

.st-btn--sm {
  padding: 0.35rem 0.75rem;
  font-size: 0.78rem;
}

.st-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin: 0 0 1.1rem;
  padding: 0.25rem;
  border-radius: 14px;
  background: color-mix(in srgb, var(--st-pine) 6%, var(--st-surface));
  border: 1px solid var(--st-line);
  width: fit-content;
  max-width: 100%;
}

.st-tabs button {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--st-muted);
  font-family: var(--st-body);
  font-weight: 600;
  font-size: 0.82rem;
  padding: 0.45rem 0.9rem;
  border-radius: 10px;
  cursor: pointer;
}

.st-tabs button.is-on {
  background: var(--st-surface);
  color: var(--st-ink);
  box-shadow: 0 2px 8px color-mix(in srgb, var(--st-pine) 14%, transparent);
}

.st-section__label {
  margin: 0 0 0.65rem;
  font-family: var(--st-display);
  font-size: 1.15rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--st-ink);
}

.st-section__hint {
  margin: -0.35rem 0 0.85rem;
  font-size: 0.84rem;
  color: var(--st-muted);
  max-width: 40rem;
  line-height: 1.4;
}

.st-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.85rem;
  margin-bottom: 1.5rem;
}

.st-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 1rem 1rem 0.9rem;
  border-radius: 16px;
  border: 1px solid var(--st-line);
  background:
    linear-gradient(165deg, color-mix(in srgb, var(--st-pine) 7%, transparent), transparent 42%),
    var(--st-surface);
  box-shadow: 0 10px 28px color-mix(in srgb, var(--st-pine) 8%, transparent);
  transition: transform 0.2s var(--st-ease), box-shadow 0.2s var(--st-ease);
  min-height: 0;
  animation: st-rise 0.45s var(--st-ease) both;
}

.st-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px color-mix(in srgb, var(--st-pine) 14%, transparent);
}

.st-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
}

.st-card__title {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--text-color);
}

.st-card__desc {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--st-muted);
  flex: 1 1;
}

.st-pill {
  flex-shrink: 0;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
}

.st-pill--layout {
  background: color-mix(in srgb, var(--st-pine) 14%, transparent);
  color: var(--st-ink);
}

.st-pill--block {
  background: color-mix(in srgb, #0f766e 14%, transparent);
  color: #0f766e;
}

.st-pill--session {
  background: color-mix(in srgb, #b45309 14%, transparent);
  color: #b45309;
}

.st-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.7rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--st-muted);
}

.st-meta span {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

/* Visual hall diagram for layouts */
.st-hall {
  display: grid;
  gap: 0.35rem;
  margin: 0.15rem 0 0.25rem;
}

.st-hall--2 {
  grid-template-columns: 1fr 1fr;
}

.st-hall--3 {
  grid-template-columns: repeat(3, 1fr);
}

.st-hall--1 {
  grid-template-columns: 1fr;
}

.st-lane {
  border-radius: 10px;
  border: 1px dashed color-mix(in srgb, var(--st-pine) 35%, transparent);
  background: color-mix(in srgb, var(--st-pine) 6%, transparent);
  padding: 0.45rem 0.4rem;
  text-align: center;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--st-ink);
  min-height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
}

.st-lane[data-mode="independent"] {
  border-style: solid;
  background: color-mix(in srgb, #b45309 8%, transparent);
  border-color: color-mix(in srgb, #b45309 35%, transparent);
  color: #92400e;
}

/* Sequence timeline for training blocks */
.st-seq {
  list-style: none;
  margin: 0.2rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  max-height: 11rem;
  overflow: auto;
}

.st-seq li {
  display: grid;
  grid-template-columns: 1.1rem 1fr auto;
  gap: 0.35rem;
  align-items: start;
  font-size: 0.74rem;
  line-height: 1.25;
}

.st-seq__n {
  font-weight: 700;
  color: var(--st-pine);
  font-variant-numeric: tabular-nums;
}

.st-seq__name {
  color: var(--text-color);
  font-weight: 600;
}

.st-seq__name--personalized {
  color: var(--brand-primary, #0877bc);
  font-weight: 800;
}

.st-seq__roles {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.st-role {
  font-size: 0.62rem;
  font-weight: 700;
  padding: 0.1rem 0.35rem;
  border-radius: 999px;
}

.st-role--perf {
  background: color-mix(in srgb, var(--st-perf) 16%, transparent);
  color: var(--st-perf);
}

.st-role--spar {
  background: color-mix(in srgb, var(--st-spar) 16%, transparent);
  color: var(--st-spar);
}

.st-card__foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-top: auto;
  padding-top: 0.35rem;
}

.st-card__actions {
  display: flex;
  gap: 0.25rem;
}

.st-icon-btn {
  appearance: none;
  border: 0;
  background: color-mix(in srgb, var(--st-pine) 8%, transparent);
  color: var(--st-ink);
  width: 2rem;
  height: 2rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.st-icon-btn--danger {
  color: #dc2626;
  background: color-mix(in srgb, #dc2626 8%, transparent);
}

.st-empty {
  padding: 2rem 1.25rem;
  text-align: center;
  border-radius: 16px;
  border: 1px dashed var(--st-line);
  background: color-mix(in srgb, var(--st-pine) 4%, var(--st-surface));
  color: var(--st-muted);
  font-size: 0.92rem;
  line-height: 1.45;
}

.st-loading {
  height: 3px;
  border-radius: 99px;
  background: color-mix(in srgb, var(--st-pine) 12%, transparent);
  overflow: hidden;
  margin-bottom: 1rem;
}

.st-loading span {
  display: block;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, var(--st-pine), #38bdf8);
  animation: st-slide 1s ease-in-out infinite alternate;
}

@keyframes st-slide {
  from { transform: translateX(0); }
  to { transform: translateX(150%); }
}

@keyframes st-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .st-card,
  .st-loading span,
  .st-btn {
    animation: none;
    transition: none;
  }
}

@media (max-width: 640px) {
  .st-hall--3 {
    grid-template-columns: 1fr;
  }

  .st-hero__title {
    font-size: 1.7rem;
  }
}

.tst-assign-mode {
  display: inline-flex;
  margin-bottom: 10px;
  padding: 3px;
  border-radius: 999px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.4));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);
}

.tst-assign-mode__btn {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--text-secondary, #64748b);
  border-radius: 999px;
  padding: 6px 12px;
  font: inherit;
  font-size: 0.82rem;
  font-weight: 650;
  cursor: pointer;
}

.tst-assign-mode__btn.is-active {
  background: var(--brand-primary, #0877bc);
  color: #fff;
}

.tst-assign-mode__btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/TrainingSessionTemplates.css"],"names":[],"mappings":"AAEA,2EAA2E;AAC3E;EACE,wCAAwC;EACxC,kEAAkE;EAClE,8FAA8F;EAC9F,0CAA0C;EAC1C,wCAAwC;EACxC,yCAAyC;EACzC,oEAAoE;EACpE,0DAA0D;EAC1D,kBAAkB;EAClB,kBAAkB;;EAElB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd;;;;6CAI2C;EAC3C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ;;wGAEsG;AACxG;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oEAAoE;EACpE,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oEAAoE;EACpE,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gCAAgC;EAChC;;qBAEmB;EACnB,0EAA0E;EAC1E,yEAAyE;EACzE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,oBAAoB;AACtB;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sEAAsE;EACtE,8DAA8D;EAC9D,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uDAAuD;EACvD,0DAA0D;EAC1D,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,8DAA8D;EAC9D,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,oEAAoE;EACpE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,+DAA+D;EAC/D,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,+DAA+D;EAC/D,6EAA6E;AAC/E;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Session templates — club board, same language as Consent / Edit Group. */\n.st-board {\n  --st-pine: var(--brand-primary, #0877bc);\n  --st-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));\n  --st-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));\n  --st-muted: var(--text-secondary, #64748b);\n  --st-surface: var(--surface-color, #fff);\n  --st-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --st-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --st-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n  --st-perf: #0f766e;\n  --st-spar: #b45309;\n\n  position: relative;\n  isolation: isolate;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding:\n    max(0.75rem, env(safe-area-inset-top, 0px))\n    max(1rem, env(safe-area-inset-right, 0px))\n    calc(1.75rem + env(safe-area-inset-bottom, 0px))\n    max(1rem, env(safe-area-inset-left, 0px));\n  color: var(--text-color);\n  font-family: var(--st-body);\n}\n\n.st-board *,\n.st-board *::before,\n.st-board *::after {\n  box-sizing: border-box;\n}\n\n.st-board__glow {\n  pointer-events: none;\n  position: absolute;\n  z-index: -1;\n  inset: -4% -10% auto;\n  height: 180px;\n  opacity: 0.8;\n  background:\n    radial-gradient(48% 70% at 8% 18%, color-mix(in srgb, var(--st-pine) 18%, transparent) 0%, transparent 72%),\n    radial-gradient(34% 48% at 92% 0%, color-mix(in srgb, #0f766e 10%, transparent) 0%, transparent 68%);\n}\n\n.st-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.st-hero__copy {\n  min-width: 0;\n  max-width: 42rem;\n}\n\n.st-hero__kicker {\n  margin: 0 0 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--st-muted);\n}\n\n.st-hero__title {\n  margin: 0;\n  font-family: var(--st-display);\n  font-size: clamp(1.85rem, 3.2vw, 2.55rem);\n  font-weight: 700;\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--st-ink);\n}\n\n.st-hero__sub {\n  margin: 0.45rem 0 0;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: var(--st-muted);\n  max-width: 38rem;\n}\n\n.st-hero__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.st-btn {\n  appearance: none;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  padding: 0.55rem 1.05rem;\n  font-family: var(--st-body);\n  font-size: 0.86rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.18s var(--st-ease), box-shadow 0.18s var(--st-ease), background 0.18s;\n}\n\n.st-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.st-btn--primary {\n  background: var(--st-pine);\n  color: #fff;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--st-pine) 28%, transparent);\n}\n\n.st-btn--primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background: var(--st-ink);\n}\n\n.st-btn--ghost {\n  background: color-mix(in srgb, var(--st-pine) 8%, var(--st-surface));\n  color: var(--st-ink);\n  border-color: color-mix(in srgb, var(--st-pine) 28%, transparent);\n}\n\n.st-btn--ghost:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--st-pine) 14%, var(--st-surface));\n}\n\n.st-btn--sm {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.78rem;\n}\n\n.st-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin: 0 0 1.1rem;\n  padding: 0.25rem;\n  border-radius: 14px;\n  background: color-mix(in srgb, var(--st-pine) 6%, var(--st-surface));\n  border: 1px solid var(--st-line);\n  width: fit-content;\n  max-width: 100%;\n}\n\n.st-tabs button {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: var(--st-muted);\n  font-family: var(--st-body);\n  font-weight: 600;\n  font-size: 0.82rem;\n  padding: 0.45rem 0.9rem;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.st-tabs button.is-on {\n  background: var(--st-surface);\n  color: var(--st-ink);\n  box-shadow: 0 2px 8px color-mix(in srgb, var(--st-pine) 14%, transparent);\n}\n\n.st-section__label {\n  margin: 0 0 0.65rem;\n  font-family: var(--st-display);\n  font-size: 1.15rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--st-ink);\n}\n\n.st-section__hint {\n  margin: -0.35rem 0 0.85rem;\n  font-size: 0.84rem;\n  color: var(--st-muted);\n  max-width: 40rem;\n  line-height: 1.4;\n}\n\n.st-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 1.5rem;\n}\n\n.st-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 1rem 1rem 0.9rem;\n  border-radius: 16px;\n  border: 1px solid var(--st-line);\n  background:\n    linear-gradient(165deg, color-mix(in srgb, var(--st-pine) 7%, transparent), transparent 42%),\n    var(--st-surface);\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--st-pine) 8%, transparent);\n  transition: transform 0.2s var(--st-ease), box-shadow 0.2s var(--st-ease);\n  min-height: 0;\n  animation: st-rise 0.45s var(--st-ease) both;\n}\n\n.st-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 16px 34px color-mix(in srgb, var(--st-pine) 14%, transparent);\n}\n\n.st-card__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.st-card__title {\n  margin: 0;\n  font-size: 1.02rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--text-color);\n}\n\n.st-card__desc {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: var(--st-muted);\n  flex: 1;\n}\n\n.st-pill {\n  flex-shrink: 0;\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 0.22rem 0.5rem;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.st-pill--layout {\n  background: color-mix(in srgb, var(--st-pine) 14%, transparent);\n  color: var(--st-ink);\n}\n\n.st-pill--block {\n  background: color-mix(in srgb, #0f766e 14%, transparent);\n  color: #0f766e;\n}\n\n.st-pill--session {\n  background: color-mix(in srgb, #b45309 14%, transparent);\n  color: #b45309;\n}\n\n.st-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 0.7rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--st-muted);\n}\n\n.st-meta span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* Visual hall diagram for layouts */\n.st-hall {\n  display: grid;\n  gap: 0.35rem;\n  margin: 0.15rem 0 0.25rem;\n}\n\n.st-hall--2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n.st-hall--3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.st-hall--1 {\n  grid-template-columns: 1fr;\n}\n\n.st-lane {\n  border-radius: 10px;\n  border: 1px dashed color-mix(in srgb, var(--st-pine) 35%, transparent);\n  background: color-mix(in srgb, var(--st-pine) 6%, transparent);\n  padding: 0.45rem 0.4rem;\n  text-align: center;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--st-ink);\n  min-height: 2.4rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1.2;\n}\n\n.st-lane[data-mode=\"independent\"] {\n  border-style: solid;\n  background: color-mix(in srgb, #b45309 8%, transparent);\n  border-color: color-mix(in srgb, #b45309 35%, transparent);\n  color: #92400e;\n}\n\n/* Sequence timeline for training blocks */\n.st-seq {\n  list-style: none;\n  margin: 0.2rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  max-height: 11rem;\n  overflow: auto;\n}\n\n.st-seq li {\n  display: grid;\n  grid-template-columns: 1.1rem 1fr auto;\n  gap: 0.35rem;\n  align-items: start;\n  font-size: 0.74rem;\n  line-height: 1.25;\n}\n\n.st-seq__n {\n  font-weight: 700;\n  color: var(--st-pine);\n  font-variant-numeric: tabular-nums;\n}\n\n.st-seq__name {\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.st-seq__name--personalized {\n  color: var(--brand-primary, #0877bc);\n  font-weight: 800;\n}\n\n.st-seq__roles {\n  display: flex;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.st-role {\n  font-size: 0.62rem;\n  font-weight: 700;\n  padding: 0.1rem 0.35rem;\n  border-radius: 999px;\n}\n\n.st-role--perf {\n  background: color-mix(in srgb, var(--st-perf) 16%, transparent);\n  color: var(--st-perf);\n}\n\n.st-role--spar {\n  background: color-mix(in srgb, var(--st-spar) 16%, transparent);\n  color: var(--st-spar);\n}\n\n.st-card__foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: auto;\n  padding-top: 0.35rem;\n}\n\n.st-card__actions {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.st-icon-btn {\n  appearance: none;\n  border: 0;\n  background: color-mix(in srgb, var(--st-pine) 8%, transparent);\n  color: var(--st-ink);\n  width: 2rem;\n  height: 2rem;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.st-icon-btn--danger {\n  color: #dc2626;\n  background: color-mix(in srgb, #dc2626 8%, transparent);\n}\n\n.st-empty {\n  padding: 2rem 1.25rem;\n  text-align: center;\n  border-radius: 16px;\n  border: 1px dashed var(--st-line);\n  background: color-mix(in srgb, var(--st-pine) 4%, var(--st-surface));\n  color: var(--st-muted);\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.st-loading {\n  height: 3px;\n  border-radius: 99px;\n  background: color-mix(in srgb, var(--st-pine) 12%, transparent);\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.st-loading span {\n  display: block;\n  height: 100%;\n  width: 40%;\n  background: linear-gradient(90deg, var(--st-pine), #38bdf8);\n  animation: st-slide 1s ease-in-out infinite alternate;\n}\n\n@keyframes st-slide {\n  from { transform: translateX(0); }\n  to { transform: translateX(150%); }\n}\n\n@keyframes st-rise {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .st-card,\n  .st-loading span,\n  .st-btn {\n    animation: none;\n    transition: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .st-hall--3 {\n    grid-template-columns: 1fr;\n  }\n\n  .st-hero__title {\n    font-size: 1.7rem;\n  }\n}\n\n.tst-assign-mode {\n  display: inline-flex;\n  margin-bottom: 10px;\n  padding: 3px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.4));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, transparent);\n}\n\n.tst-assign-mode__btn {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: var(--text-secondary, #64748b);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font: inherit;\n  font-size: 0.82rem;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.tst-assign-mode__btn.is-active {\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.tst-assign-mode__btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
